import script from "./OrderModal.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderModal.vue?vue&type=script&setup=true&lang=js"

import "./OrderModal.vue?vue&type=style&index=0&id=5637582e&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5637582e"]])

export default __exports__